import React from 'react';
import {
  Button,
  Popover,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from 'reactstrap';
import EditDocumentTypeConfigModal from '../modals/EditDocumentTypeConfigModal';
import DeleteDocumentTypeConfigModal from '../modals/DeleteDocumentTypeConfigModal';
import NewDocumentTypeConfigModal from '../modals/NewDocumentTypeConfigModal';
import { connect } from 'react-redux';
import MoreVert from '../../images/sharp-more_vert-24px.svg';
import { Flag } from 'flagger/react';
import { withAlert } from 'react-alert';

class DocumentTypeConfigPopoveritem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
      modal: false,
      editmodal: false,
      deleteModal: false,
      associated: false,
      copymodal: false,
      isCopy: false,
    };

    this.toggle = this.toggle.bind(this);
    this.editdocument = this.editdocument.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.toggleDeleteDocument = this.toggleDeleteDocument.bind(this);
    this.copydocument = this.copydocument.bind(this);
    this.togglecopymodal = this.togglecopymodal.bind(this);
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }

  componentDidUpdate(prevProps) {}

  toggleDeleteDocument() {
    this.setState({
      deleteModal: !this.state.deleteModal,
      popoverOpen: false,
    });
  }

  editdocument() {
    this.toggle();
    this.toggleEditModal();
  }

  copydocument() {
    this.toggle();

    this.setState({ isCopy: true }, () => {
      this.togglecopymodal();
    });
  }

  toggleEditModal() {
    try {
      this.setState({
        editmodal: !this.state.editmodal,
        popoverOpen: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  togglecopymodal() {
    try {
      this.setState({
        copymodal: !this.state.copymodal,
        popoverOpen: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const { localisation } = this.props.userReducer;

    //seperate style for hidden input.
    var style = {};
    style.display = 'none';
    let popoverItems = [];
    const { id, fileid } = this.props;
    let tick = <div />;

    let editDocumentModalPopup = {};
    let copyDocumentModalPopup = {};
    let deletePrintDestinationModal = {};

    //Bug 11684:Under Printer Destinations, the delete doesn't fit in edit destination box

    popoverItems.push(
      <a
        class="s-list-default-btn-default s-popup-menu-no-icon"
        onClick={this.editdocument}
        title="Edit"
      >
        <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-create" />{' '}
        {localisation['popover_edit']
          ? localisation['popover_edit'].element_lang
          : ''}
      </a>
    );
    popoverItems.push(
      <a
        class="s-list-default-btn-default s-with-icon"
        onClick={this.toggleDeleteDocument}
        title="Delete"
      >
        <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete">
          
        </div>{' '}
        {localisation['popover_delete']
          ? localisation['popover_delete'].element_lang
          : ''}
      </a>
    );
    popoverItems.push(
      <a
        class="s-list-default-btn-default s-popup-menu-no-icon"
        onClick={this.copydocument}
        title="Copy"
      >
        <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-create" />{' '}
        {localisation['popover_copy']
          ? localisation['popover_copy'].element_lang
          : ''}
      </a>
    );

    //popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.toggleDeleteDocument}  title="Delete"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete"></div> Delete</a>)
    //popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.editdocument} title="Edit"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Edit</a>)

    if (this.state.editmodal)
      editDocumentModalPopup = (
        <EditDocumentTypeConfigModal
          refresh={this.props.refresh}
          visible={this.state.editmodal}
          toggle={this.toggleEditModal}
          destination={fileid}
        />
      );
    else editDocumentModalPopup = <div />;

    if (this.state.copymodal)
      copyDocumentModalPopup = (
        <NewDocumentTypeConfigModal
          refresh={this.props.refresh}
          visible={this.state.copymodal}
          toggle={this.togglecopymodal}
          destination={fileid}
          isCopy={this.state.isCopy}
        />
      );
    else copyDocumentModalPopup = <div />;

    if (this.state.deleteModal) {
      deletePrintDestinationModal = (
        <DeleteDocumentTypeConfigModal
          modal={this.state.deleteModal}
          refresh={this.props.refresh}
          toggle={this.toggleDeleteDocument}
          destination={fileid}
          name={this.props.filename}
        />
      );
    } else deletePrintDestinationModal = <div />;

    return (
      <span>
        {tick}
        <Flag flag="v12" entity={{ id: 1 }} case="off">
          <Button
            className="s-record-picker s-fonticon-btn s-btn-menus"
            color="secondary"
            id={id}
            onClick={this.toggle}
          >
            
          </Button>
        </Flag>
        <Flag flag="v12" entity={{ id: 1 }} case="off">
          <Button
            className="s-record-picker s-fonticon-btn s-btn-menus"
            color="secondary"
            id={id}
            onClick={this.toggle}
          >
            
          </Button>
        </Flag>
        <Flag flag="v12" entity={{ id: 1 }} case="on">
          <Button
            className="s-record-picker s-fonticon-btn s-btn-menus"
            color="secondary"
            id={id}
            onClick={this.toggle}
          >
            <img src={MoreVert} />
          </Button>
        </Flag>
        <Popover
          placement="top"
          hideArrow={true}
          isOpen={this.state.popoverOpen}
          target={id}
          toggle={this.toggle}
        >
          {popoverItems}
        </Popover>
        {deletePrintDestinationModal}
        {editDocumentModalPopup}
        {copyDocumentModalPopup}
      </span>
    );
  }
}

export default connect((state) => state)(DocumentTypeConfigPopoveritem);
